// extracted by mini-css-extract-plugin
export default {"screen":"zWBUmifd","header":"ZxeBZb_6","eyebrow":"RHIjggZw","title":"NZPefWQa","list":"eqS6rrsj","cardLink":"dHb5H7Io","skeleton":"ry7vtbM9","empty":"MDkcXUuR"};